import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDesktop } from '@fortawesome/free-solid-svg-icons';
import { EmptyStateProps } from './types';
import { EmptyStateContainer, EmptyStateIcon, EmptyStateText, EmptyStateSubtext } from './styles';
import { MESSAGES } from './constants';

export const EmptyState: React.FC<EmptyStateProps> = ({ hasFilters, isDark }) => {
  return (
    <EmptyStateContainer>
      <EmptyStateIcon $isDark={isDark}>
        <FontAwesomeIcon icon={faDesktop} size="3x" />
      </EmptyStateIcon>
      <EmptyStateText $isDark={isDark}>
        {MESSAGES.NO_DEVICES_FOUND}
      </EmptyStateText>
      <EmptyStateSubtext $isDark={isDark}>
        {hasFilters ? MESSAGES.ADJUST_SEARCH : MESSAGES.ADD_FIRST_DEVICE}
      </EmptyStateSubtext>
    </EmptyStateContainer>
  );
};
